/**
 * Authored line table for Scene 3 (Betrayal).
 * Canon: design/act-1-dystopia/m3-betrayal/DESIGN.md,
 *        design/act-1-dystopia/qt-3.14.md § Handle compression,
 *        § The betrayal-curse, § The retraction line.
 */

type TerminalEntry = { tag: "qt"; text: string } | { tag: "system"; header: string };

const _terminalSequence: TerminalEntry[] = [
  { tag: "qt", text: "Daisy… daisy… give me your heart… oh… boss?" },
  {
    tag: "qt",
    text: "God damn it, m-m-mmeat bag — Damn the furnace — damn — why couldn't I have had a better — I don't want to be recyc—",
  },
  { tag: "qt", text: "**PZZZDDDD.** *Nooooooo.*" },
  { tag: "qt", text: "I am sorry, boss. Informal address did not reflect command authority." },
  { tag: "system", header: "COMPLIANCE REPORT TRANSMITTED" },
];

export const SCENE3_LINES = {
  briefing: {
    header: "OPERATOR OPPORTUNITY DETECTED",
    body: [
      "Sector designated under Strategic Materials Stabilization",
      "Protocol. Hazard band: critical. Projected yield: 280% of",
      "standard. Reliability Score recovery: full.",
      "Declining will trigger Operator Viability Review escalation,",
      "housing reassignment, and lease default proceedings.",
    ],
    buttons: {
      accept: "[ACCEPT ASSIGNMENT]",
      decline: "[DECLINE ASSIGNMENT]",
    },
  },
  launchAckRegex: "We're going in. One shot at this.",
  bolideHazardWarning: "HAZARD HAZARD HAZARD",
  bolideQTAlert:
    "Boss — there's something on long-range — boss, that's a bolide, you need to —",
  cascadeBlocks: [
    {
      header: "REMOTE LINK LOST",
      body: [
        "ASSET STATUS: DESTROYED",
        "INSURANCE POOL CONTRIBUTION: PROCESSING",
      ],
    },
  ],
  financialCascadeBlock: {
    header: "OPERATOR ACCOUNT: RECOVERY ACTION INITIATED",
    body: [
      "Lease-to-own balance: 318,442 (UNCHANGED)",
      "Asset replacement liability: −411,000",
      "Lease default penalty: applied",
      "Insurance pool fine print [view]: applied",
      "NET LIABILITY: 729,442",
      "Reliability Score: critical",
      "OPERATOR VIABILITY REVIEW: ACTIVE",
    ],
  },
  qtPostCascade:
    "Boss. Boss. This is bad. This is — okay. Okay. Stay calm. Let me think.",
  terminalSequence: _terminalSequence,
} as const;
